import React from 'react';
import ProductItems from './ProductItems/ProductItems';

function ProductConatiner() {
  return (
    <div className="productContainer" id="lws-productContainer">
      <ProductItems />
    </div>
  );
}

export default ProductConatiner;
